import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from ".";
import {
  ACCESS_TOKEN_NAME,
} from "../shared/constants";
import { useGetMeQuery } from "../services/me";
import "dayjs/locale/ja";
import { useEffect } from "react";
import { config } from "../config";
import { useTranslation } from "react-i18next";
import { Skeleton } from "antd";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const location = useLocation();
  const accessToken = localStorage.getItem(ACCESS_TOKEN_NAME) || "";
  if (!accessToken) {
    navigate(ROUTES.PATHS.LOGIN);
  }
  if (accessToken) {
    const {
      data: userData,
      isLoading: isUserLoading,
      isError: isUserError,
      error: userErrorData,
      isSuccess: isUserSuccess
    } = useGetMeQuery(accessToken);

    useEffect(() => {
      const changeLanguageAsync = async () => {
        if (isUserSuccess) {
          i18n.services.backendConnector.backend.options.loadPath =
            config.translationUrl;
          await i18n.changeLanguage(userData?.language ?? "en");
        }
      };
      changeLanguageAsync();

    }, [isUserSuccess]);

    // accessToken && useGetUnreadNotificationCountQuery({})
    if (isUserLoading) return <div className="mt-5 ml-5" ><Skeleton active /></div>;

    if (!isUserLoading) {
      if (isUserError) {
        const error = userErrorData as any;
        if (error.status === 400) {
        }
      }
    }
  }
  return children;
};

export default PrivateRoute;
